import FontAwesomeIcon from './FontAwesomeIcon';
import { illustrations_2, illustrations_3, illustrations_4 } from '../utils/images';
import {
	FaultReporting,
	PreventiveMaintenance,
	AssetManagement,
	QrCodeScanning,
	PhotoAndVideoEvidence,
	Statistics,
	FacilityAndRoomBooking,
	Surveys,
	Broadcasts,
	AutomatedFaqResponse,
	VisitorManagement,
} from '../components/Svg';

export default function Features() {
	return (
		<section className="features">
			<div className="container">
				<div className="heading-container">
					<div className="heading">
						<h2 className="heading__title">Use a single platform for all your Facilities Management needs</h2>

						<span className="heading__desc">
							FacilityBot is a feature-packed Facilities Management Software. Here are our top features
						</span>
					</div>
				</div>

				<div className="features__row features__row--pb-10rem">
					<div className="features__content">
						<h3 className="features__introduce">Full Fledged Computerised Maintenance Management System (CMMS)</h3>

						<div className="features__row features__row--article">
							<div className="features__article">
								<div className="features__article-icon">
									<Statistics />
								</div>
								<span className="features__article-title">Statistics, Audit Trail and KPIs</span>
								<div className="features__article-desc">
									Reports are auto-generated and tracked against custom KPIs. Workflow history, conversation transcripts
									and photo and video evidence provides the industry’s best available audit trail.
								</div>
							</div>

							<div className="features__article">
								<div className="features__article-icon">
									<PhotoAndVideoEvidence />
								</div>
								<span className="features__article-title">Photo and Video Evidence</span>
								<div className="features__article-desc">
									Fault reporters easily upload photos through their messaging apps. Technicians easily upload response
									and rectification photos and videos through the FacilityBot Mobile App and Web Portal.
								</div>
							</div>
						</div>
					</div>

					<img
						loading="lazy"
						src={illustrations_2}
						alt="Computerised Maintenance Management System"
						className="features__illustration"
					/>
				</div>

				<div className="features__row features__row--pb-10rem">
					<img loading="lazy" src={illustrations_3} alt="Features" className="features__illustration" />

					<div className="features__content">
						<div className="features__row features__row--mb-3rem features__row--article">
							<div className="features__article">
								<div className="features__article-icon">
									<FaultReporting />
								</div>
								<span className="features__article-title">Fault Reporting</span>
								<div className="features__article-desc">
									Seamless fault reporting through messaging platforms. Automated alerts and assignment, workflow
									tracking and more!
								</div>
							</div>
							<div className="features__article">
								<div className="features__article-icon">
									<AssetManagement />
								</div>
								<span className="features__article-title">Asset Management</span>
								<div className="features__article-desc">
									Import assets into the system and track their fault report and preventive maintenance history
								</div>
							</div>
						</div>
						<div className="features__row features__row--article">
							<div className="features__article">
								<div className="features__article-icon">
									<QrCodeScanning />
								</div>
								<span className="features__article-title">Asset QR Code Scanning</span>
								<div className="features__article-desc">
									Generate QR codes of Asset IDs and use the FacilityBot App to scan them for the Asset Maintenance
									History
								</div>
							</div>
							<div className="features__article">
								<div className="features__article-icon">
									<PreventiveMaintenance />
								</div>
								<span className="features__article-title">Preventive Maintenance</span>
								<div className="features__article-desc">
									Digitise and schedule preventive maintenance activities. No more paper checklists. Track all
									preventive maintenance activity in one portal.
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="features__row features__row--pb-30rem">
					<div className="features__content features__content--w70">
						<h3 className="features__introduce">
							<span>Facility</span>Bot is more than a CMMS. It can be the primary communications channel with building
							users.
						</h3>

						<div className="features__row features__row--mb-7rem features__row--article">
							<div className="features__article features__article--divided-3">
								<div className="features__article-icon">
									<FontAwesomeIcon name={'fas fa-globe-asia'} />
								</div>
								<span className="features__article-title">Multi-Language</span>
								<div className="features__article-desc">
									FacilityBot understands 109 languages ! Are some of your users more comfortable in languages besides
									English? No problem, FacilityBot can chat with Requestors in their preferred language.
								</div>
							</div>
							<div className="features__article features__article--divided-3">
								<div className="features__article-icon">
									<VisitorManagement />
								</div>
								<span className="features__article-title">Visitor Management</span>
								<div className="features__article-desc">
									Allow tenants to invite guests to your building using FacilityBot. Reduce reception workload and
									enhance security
								</div>
							</div>
							<div className="features__article features__article--divided-3">
								<div className="features__article-icon">
									<FacilityAndRoomBooking />
								</div>
								<span className="features__article-title">Facility and Room Booking</span>
								<div className="features__article-desc">
									Allow tenants to book facilities, rooms or equipment through the same chatbot. Simply ask the chatbot
									to help. What can be simpler?
								</div>
							</div>
						</div>

						<div className="features__row features__row--article">
							<div className="features__article features__article--divided-3">
								<div className="features__article-icon">
									<Surveys />
								</div>
								<span className="features__article-title">Conduct Surveys</span>
								<div className="features__article-desc">
									Configure custom surveys, broadcast these to tenants wait for response Facilitybot will display the
									results in tabular and graphical formats
								</div>
							</div>
							<div className="features__article features__article--divided-3">
								<div className="features__article-icon">
									<Broadcasts />
								</div>
								<span className="features__article-title">Send Broadcasts</span>
								<div className="features__article-desc">
									Send custom broadcasts to tenants. Inform them of events, fire drills or notify them of building
									renovations. Treat this as a digital notice board.
								</div>
							</div>
							<div className="features__article features__article--divided-3">
								<div className="features__article-icon">
									<AutomatedFaqResponse />
								</div>
								<span className="features__article-title">Automated FAQ Response</span>
								<div className="features__article-desc">
									Facilitybot is a chatbot after all. So it uses artificial intelligence to answer ad-hoc questions by
									tenants. Simply configure the questions and answers and let the bot handle FAQs for you.
								</div>
							</div>
						</div>
					</div>

					<img
						loading="lazy"
						src={illustrations_4}
						alt="Prominent Features"
						className="features__illustration features__illustration--absolute"
					/>
				</div>
			</div>
		</section>
	);
}
